import { Box, Chip, Typography } from '@mui/material';
import { Modality } from '~/domain/dicom/modality';

export default function ModalitySelect({
    modality,
    setModality,
}: {
    modality: Modality[];
    setModality: (modality: Modality[]) => void;
}) {
    const availableModalities: Modality[] = [Modality.CT, Modality.MR];

    const handleSelectModality = (mod: Modality) => {
        setModality(modality[0] === mod ? [] : [mod]);
    };

    return (
        <Box display="flex" gap={0.5} alignItems="center">
            <Typography fontSize={12}>Modality:</Typography>
            {availableModalities.map((mod) => (
                <Chip
                    key={mod}
                    label={mod}
                    size="small"
                    color={modality[0] === mod ? 'primary' : 'default'}
                    variant={modality[0] === mod ? 'filled' : 'outlined'}
                    onClick={() => handleSelectModality(mod)}
                    sx={{
                        lineHeight: 'initial',
                        border: '1px solid',
                        borderColor:
                            modality[0] === mod
                                ? 'transparent'
                                : 'currentColor',
                    }}
                />
            ))}
        </Box>
    );
}
